import { render, staticRenderFns } from "./SingleAnnotationComponent.vue?vue&type=template&id=5b7540bc&"
import script from "./SingleAnnotationComponent.vue?vue&type=script&lang=js&"
export * from "./SingleAnnotationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports